<template>
  <section>
    <TemplateOneServices v-if="selectedTemplate == 'One'"></TemplateOneServices>
  </section>
</template>

<script>
import TemplateOneServices from "@/views/components/SmartCardTemplate/Services.vue"

export default {
  name: "smartCard",
  data() {
    return {
      selectedTemplate: "One"
    }
  },
  components: {
    TemplateOneServices
  },
  async created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
  },
};
</script>

<style scoped lang="scss">

</style>
